import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* discount(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/discount/discount/' : config.credentials.url + '/discount/discount/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "DISCOUNT_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "DISCOUNT_RESPONSE", value: error })
    }
}

function* discounts(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/discount/discount/?offset=0&limit=' + actions.limit : config.credentials.url + '/discount/discount/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "DISCOUNTS_RESPONSE_LIST", value: response })
    } catch (error) {
        yield put({ type: "DISCOUNTS_RESPONSE_LIST", value: error })
    }
}

function* remove(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/discount/discount/' + actions.data + '/', requestOptions)

        yield put({ type: "DISCOUNT_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "DISCOUNT_RESPONSE", value: error })
    }
}

function* edit(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/discount/discount/' + actions.id + '/', requestOptions)

        yield put({ type: "DISCOUNT_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "DISCOUNT_RESPONSE", value: error })
    }
}

function* add(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const discountResponse = yield call(apiCall, 'POST', config.credentials.url + '/discount/discount/', requestOptions);

        yield put({ type: "DISCOUNT_RESPONSE", value: discountResponse })

    } catch (error) {
        yield put({ type: "DISCOUNT_RESPONSE", value: error })
    }
}

function* categories(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/discount/discount_category/?offset=0&limit=' + actions.limit : config.credentials.url + '/discount/discount_category/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "CATEGORIESNAME_RESPONSE_LIST", value: response })
    } catch (error) {
        yield put({ type: "CATEGORIESNAME_RESPONSE_LIST", value: error })
    }
}

function* addCategoryN(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/discount/discount_category/', requestOptions);

        yield put({ type: "CATEGORIESNAME_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "CATEGORIESNAME_RESPONSE", value: error })
    }
}

function* editCategoryN(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/discount/discount_category/' + actions.id + '/', requestOptions)

        yield put({ type: "CATEGORIESNAME_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "CATEGORIESNAME_RESPONSE", value: error })
    }
}

function* discountsHistory(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/discount/used_coupon/?offset=0&limit=' + actions.limit : config.credentials.url + '/discount/used_coupon/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "DISCOUNTS_HISTORY_RESPONSE_LIST", value: response })
    } catch (error) {
        yield put({ type: "DISCOUNTS_HISTORY_RESPONSE_LIST", value: error })
    }
}

function* discountHistory(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/discount/used_coupon/' : config.credentials.url + '/discount/used_coupon/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "DISCOUNT_HISTORY_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "DISCOUNT_HISTORY_RESPONSE", value: error })
    }
}

function* hashExportHistoryCoupons(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        let url =
            actions.query === null
                ? config.credentials.url + '/discount/report_used_coupons/?offset=0&limit=1000000'
                : config.credentials.url + '/discount/report_used_coupons/' + actions.query + '&offset=0&limit=100000';

        const response = yield call(apiCall, 'get', url, requestOptions);
        //saveAs(response.message, "filter_Offices.xlsx")
        yield put({ type: 'HASH_EXPORT_DISCOUNTS_HISTORY_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'HASH_EXPORT_DISCOUNTS_HISTORY_RESPONSE', value: error });
    }
}

function* checkExportHistoryCoupons(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_DISCOUNTS_HISTORY_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_DISCOUNTS_HISTORY_RESPONSE', value: error });
    }
}

function* updateExportHistoryCoupons(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'PUT',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'UPDATE_EXPORT_DISCOUNTS_HISTORY_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'UPDATE_EXPORT_DISCOUNTS_HISTORY_RESPONSE', value: error });
    }
}

function* hashExportDiscounts(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        let url =
            actions.query === null
                ? config.credentials.url + '/discount/report_coupons/?offset=0&limit=1000000'
                : config.credentials.url +
                '/discount/report_coupons/' +
                actions.query +
                '&offset=0&limit=100000';
        const response = yield call(apiCall, 'get', url, requestOptions);

        yield put({ type: 'HASH_EXPORT_DISCOUNTS_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'HASH_EXPORT_DISCOUNTS_RESPONSE', value: error });
    }
}
function* checkExportDiscounts(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_DISCOUNTS_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_DISCOUNTS_RESPONSE', value: error });
    }
}

function* updateExportDiscounts(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'PUT',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'UPDATE_EXPORT_DISCOUNTS_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'UPDATE_EXPORT_DISCOUNTS_RESPONSE', value: error });
    }
}

export function* getDiscount() {
    yield takeEvery("GET_DISCOUNT", discount)
}

export function* getDiscountsList() {
    yield takeEvery("GET_DISCOUNTS", discounts)
}

export function* addDiscount() {
    yield takeEvery("ADD_DISCOUNT", add)
}

export function* editDiscount() {
    yield takeEvery("EDIT_DISCOUNT", edit)
}

export function* removeDiscount() {
    yield takeEvery("REMOVE_DISCOUNT", remove)
}

export function* getCategoryNameListSent() {
    yield takeEvery("GET_CATEGORIESNAME", categories)
}

export function* addCategoryName() {
    yield takeEvery("ADD_CATERORYNAME", addCategoryN)
}

export function* editCategoryName() {
    yield takeEvery("EDIT_CATERORYNAME", editCategoryN)
}

export function* getDiscountsHistoryList() {
    yield takeEvery("GET_DISCOUNTS_HISTORY", discountsHistory)
}

export function* getDiscountsHistory() {
    yield takeEvery("GET_DISCOUNT_HISTORY", discountHistory)
}

export function* getHashExportHistoryCouponsList() {
    yield takeEvery('GET_HASH_EXPORT_DISCOUNTS_HISTORY', hashExportHistoryCoupons);
}

export function* checkExportHistoryCouponsList() {
    yield takeEvery('CHECK_EXPORT_DISCOUNTS_HISTORY', checkExportHistoryCoupons);
}

export function* updateExportHistoryCouponsList() {
    yield takeEvery('UPDATE_EXPORT_DISCOUNTS_HISTORY', updateExportHistoryCoupons);
}


export function* getHashExportDiscountsList() {
    yield takeEvery('GET_HASH_EXPORT_DISCOUNTS', hashExportDiscounts);
}
export function* checkExportDiscountsList() {
    yield takeEvery('CHECK_EXPORT_DISCOUNTS', checkExportDiscounts);
}
export function* updateExportDiscountsList() {
    yield takeEvery('UPDATE_EXPORT_DISCOUNTS', updateExportDiscounts);
}